
import Turbolinks from 'turbolinks'

import '../components/feedback';
import '../components/publications';
import ParticipationForm from '../influencers/participation_form'
import ProfileForm from '../influencers/profile_form'

Turbolinks.start()

window.addEventListener('turbolinks:load', () => {
  ParticipationForm()
  ProfileForm()
})
